<template>
  <subAccountCommonDialog :visible.sync="visible" title="提示" @clickCancel="clickCancel" @clickConfirm="clickConfirm">
    <template v-slot:dialogContent>删除账号操作会删除发布在此账号中的所有作品，是否确定删除？ </template>
  </subAccountCommonDialog>
</template>
<script>
import subAccountCommonDialog from './subAccountCommonDialog.vue'
export default {
  name: 'subAccountRemoveDialog',
  props: ['visible'],
  data() {
    return {
      radioValue: 1,
      inputValue: undefined
    }
  },
  methods: {
    clickCancel() {
      this.$emit('clickCancel')
    },
    clickConfirm() {
      this.$emit('clickConfirm')
    }
  },
  components: {
    subAccountCommonDialog
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 30px 20px !important;
}
</style>
